import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

export const depositInvoiceEditorVariants = [
  InvoiceEditorVariant.DepositInvoiceDraftEdit,
  InvoiceEditorVariant.DepositInvoiceNewFromQuote,
]
